export default function SaveIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55556 4V7.02222C7.55556 7.52005 7.55556 7.76896 7.65244 7.9591C7.73766 8.12636 7.87364 8.26234 8.0409 8.34756C8.23104 8.44444 8.47995 8.44444 8.97778 8.44444H15.0222C15.52 8.44444 15.769 8.44444 15.9591 8.34756C16.1264 8.26234 16.2623 8.12636 16.3476 7.9591C16.4444 7.76896 16.4444 7.52005 16.4444 7.02222V4.88889M16.4444 20V14.3111C16.4444 13.8133 16.4444 13.5644 16.3476 13.3742C16.2623 13.207 16.1264 13.071 15.9591 12.9858C15.769 12.8889 15.52 12.8889 15.0222 12.8889H8.97778C8.47995 12.8889 8.23104 12.8889 8.0409 12.9858C7.87364 13.071 7.73766 13.207 7.65244 13.3742C7.55556 13.5644 7.55556 13.8133 7.55556 14.3111V20M20 9.62265V15.7333C20 17.2268 20 17.9735 19.7094 18.544C19.4537 19.0457 19.0457 19.4537 18.544 19.7094C17.9735 20 17.2268 20 15.7333 20H8.26667C6.77319 20 6.02646 20 5.45603 19.7094C4.95426 19.4537 4.54631 19.0457 4.29065 18.544C4 17.9735 4 17.2268 4 15.7333V8.26667C4 6.77319 4 6.02646 4.29065 5.45603C4.54631 4.95426 4.95426 4.54631 5.45603 4.29065C6.02646 4 6.77319 4 8.26667 4H14.3773C14.8122 4 15.0296 4 15.2342 4.04912C15.4156 4.09267 15.589 4.1645 15.7481 4.26197C15.9275 4.37191 16.0812 4.52565 16.3887 4.83312L19.1669 7.61133C19.4744 7.9188 19.6281 8.07253 19.738 8.25194C19.8355 8.411 19.9073 8.58441 19.9509 8.76581C20 8.97041 20 9.18782 20 9.62265Z"
        stroke={props.stroke ?? "white"}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
